// extracted by mini-css-extract-plugin
export default {"screen":"screen__9740e8da","features":"features__360e9d2f","title":"title__fdcfebb2","features_cards-wrap":"features_cards-wrap__6ef614cd"};